import styled from '@emotion/styled';
import { DatePicker, DateTimePicker, LoadingButton, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Box, Container, Stack, Divider, Grid, TextField, Typography, Autocomplete, Button, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, TablePagination, IconButton, Dialog, DialogContent, useMediaQuery, TableSortLabel, MenuItem } from '@mui/material'
import { Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useRef, useState } from 'react'
import Page from '../../components/Page'
import * as Yup from 'yup';
import { Api } from '../../components/api';
import { fDateTo } from '../../utils/formatTime';
import { useNavigate } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import TreeViewGroup from './TreeViewGroup';
import { useReactToPrint } from 'react-to-print';
import HasPermission from '../../haspermission/HasPermission';
import _ from 'lodash';

export default function OfflinedeviceByCompany({ account, userId, permissions }) {
    const navigate = useNavigate()
    const [devices, setDevices] = useState([])
    const [companys, setCompanys] = useState([])
    const [company, setCompany] = useState("all")
    const [poiLogs, setPoiLogs] = useState([])

    useEffect(() => {
        const { c_coname, contype, cogcode } = account;
        Api.get(`/v0/if/Cnames`, { headers: { CompanyGroup: cogcode } }).then((res) => {
            setCompanys(res.data)
            Api.get(`/v0/gps/devices?PageSize=9999999&Page=1`, { headers: { CompanyGroup: cogcode } })
                .then((res) => {
                    setDevices(res.data.devices)
                }
                ).catch(e => {
                    console.log('error', e)
                })
        }
        ).catch(e => {
            console.log('error', e)
        })
    }, [])

    const schema = Yup.object().shape({
        date: Yup.date().required('minute is required'),
    });
    const formik = useFormik({
        initialValues: {
            date: fDateTo(new Date(), "yyyy-MM-dd HH:mm:ss")
        },
        validationSchema: schema,
        onSubmit: (values, { setSubmitting }) => {
            const device_sub = company === "all" ? devices.map(d => {
                return d.device
            })
                :
                devices.filter((val) => {
                    return val.cname?.toUpperCase().includes(company.toUpperCase())
                }).map(d => {
                    return d.device
                })
            const req = {
                "userId": userId,
                "list": device_sub
            }
            Api.post('/Tracking/DevicesByList', req).then((res) => {
                const { data } = res
                setPoiLogs(_.orderBy(data, ["datetime"], ["asc"]))
                setSubmitting()
            }).catch((e) => {
                setPoiLogs([])
                setSubmitting()
            })
        }
    })
    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    function calculateTimeDifference(startDate) {
        const now = new Date().getTime();
        const startTimestamp = new Date(startDate).getTime();
        const difference = now - startTimestamp;
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

        return { days, hours, minutes };
        // return `${days} วัน ${hours} ชั่วโมง ${minutes} นาที`;
    }


    const filterTimeDifference = () => {
        const now = new Date();
        const cutoffTime = new Date();
        cutoffTime.setMinutes(now.getMinutes() - 30);
        return poiLogs.filter(item => {
            const itemDate = new Date(item.datetime);
            return itemDate < cutoffTime;
        });

    }
    const handleChange = (event) => {
        setCompany(event.target.value);
    };
    return (
        <Page title="Offline device">
            <Container>
                <Box flexGrow={1} padding={1}>
                    <Typography variant="h4">Event : Offline device by Company</Typography>
                </Box>
                <Box flexGrow={1} padding={1}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <FormikProvider value={formik}>
                            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                                <Grid container spacing={3}>
                                    <Grid item xs={6} >
                                        <TextField select size="small"
                                            type="text"
                                            label="บริษัท"
                                            value={company}
                                            fullWidth
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="all">
                                                <em>ทั้งหมด</em>
                                            </MenuItem>
                                            {
                                                companys.map((c, i) => {
                                                    return (
                                                        <MenuItem value={c.c_coname}>
                                                            {c.fullname}
                                                        </MenuItem>
                                                    )
                                                })
                                            }

                                        </TextField>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Stack direction="row" spacing={1} justifyContent="center">
                                            <LoadingButton
                                                style={{ height: 40, width: 80 }}
                                                // fullWidth={true}
                                                size="small"
                                                type="submit"
                                                variant="contained"
                                                loading={isSubmitting}
                                            >
                                                ค้นหา
                                            </LoadingButton>

                                            <Button
                                                style={{ height: 40, width: 80 }}
                                                // fullWidth={true}
                                                size="small"
                                                type="submit"
                                                variant="contained"
                                                color="info"
                                                onClick={() => {
                                                    navigate('/report/event')
                                                }}

                                            >
                                                กลับ
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Form>
                        </FormikProvider>
                    </LocalizationProvider>
                </Box>
            </Container >
            <MainStyle>
                <Container sx={{
                    padding: 3,
                    // justifyContent: "center", display: "flex"
                }} >
                    <Box>
                        <Stack justifyContent="space-between" direction="row" spacing={1} >
                            <Box></Box>
                            <Box>
                                {filterTimeDifference().length !== 0 && (

                                    <Stack direction="row" spacing={1}>
                                        <HasPermission permissions={permissions} scope={["print"]}>
                                            <Button onClick={handlePrint} variant="outlined">พิมพ์</Button>
                                        </HasPermission>
                                        <HasPermission permissions={permissions} scope={["download"]}>
                                            <Button
                                                as={CSVLink}
                                                filename={`${fDateTo(values.date, 'dd_MM_yyyy_HH_mm')}.csv`} data={
                                                    filterTimeDifference().map((value, index) => {
                                                        const {
                                                            device, name, datetime, poi_name, poi_id
                                                        } = value;
                                                        return {
                                                            "เลขที่อุปกรณ์": `=""${device}""`,
                                                            "ทะเบียนรถ": `=""${name}""`,
                                                            "วันที่ออนล่าสุด": `=""${fDateTo(new Date(datetime), 'dd/MM/yyyy HH:mm:ss')}""`,
                                                            "วัน": `=""${calculateTimeDifference(value.datetime)?.days}""`,
                                                            "ชั่วโมง": `=""${calculateTimeDifference(value.datetime)?.hours}""`,
                                                            "นาที": `=""${calculateTimeDifference(value.datetime)?.minutes}""`,
                                                            "สถานที่": `=""${value?.widget_bar?.value}""`,
                                                        }
                                                    }
                                                    )
                                                }
                                                variant="contained"
                                                style={{
                                                    textDecorationLine: 'none',
                                                }} >
                                                Download
                                            </Button>
                                        </HasPermission>
                                    </Stack>
                                )}

                            </Box>
                        </Stack>
                    </Box>

                    <Box ref={componentRef} className="section-to-print">
                        <Box sx={{
                            marginLeft: "0.5cm", marginRight: "0.5cm"
                        }}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width={200}>
                                                เลขที่อุปกรณ์
                                            </TableCell>
                                            <TableCell width={120}>
                                                ทะเบียนรถ
                                            </TableCell>
                                            <TableCell width={200}>
                                                วันที่ออนล่าสุด
                                            </TableCell>
                                            <TableCell width={80} align="right">
                                                วัน
                                            </TableCell>
                                            <TableCell width={80} align="right">
                                                ชั่วโมง
                                            </TableCell>
                                            <TableCell width={80} align="right">
                                                นาที
                                            </TableCell>
                                            <TableCell>
                                                สถานที่
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            filterTimeDifference().map((value, index) => {
                                                return (
                                                    <TableRow sx={{ padding: "10px" }} key={index}>
                                                        <TableCell>{value.device}</TableCell>
                                                        <TableCell>{value.name}</TableCell>
                                                        <TableCell>{fDateTo(value.datetime, 'dd/MM/yyyy HH:mm:ss')}</TableCell>
                                                        <TableCell align="right">{calculateTimeDifference(value.datetime)?.days}</TableCell>
                                                        <TableCell align="right">{calculateTimeDifference(value.datetime).hours}</TableCell>
                                                        <TableCell align="right">{calculateTimeDifference(value.datetime).minutes}</TableCell>
                                                        <TableCell>{value?.widget_bar?.value}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                </Container>
            </MainStyle>
        </Page >
    )
}

const MainStyle = styled(Box)(({ theme }) => ({
    margin: 'auto',
    overflow: 'auto',
    paddingTop: 10,
    paddingBottom: 60,
    paddingLeft: 10,
    paddingRight: 10
}));